// src/com/file_of_report/ArrivalOnTimeReportDef.js
// 정시도착 레포트 메타 정의
import { AppWord, TableColumnType } from "../../value/AppConst";
import ValueMisc from "../../value/ValueMisc";

// Mapper: ArrivalOnTimeReportMapper.xml
// 정시도착 레포트에는 제목, 헤더 등이 없음.

const getStayTime = (storeStartTime, arriveInputTime, arriveButtonTime) => {
    if(storeStartTime) {
        if(arriveInputTime) {
            return ValueMisc.parseAndMinusToHhmm(storeStartTime, arriveInputTime, true);
        }
        else if(arriveButtonTime) {
            return ValueMisc.parseAndMinusToHhmm(storeStartTime, arriveButtonTime, true);
        }
    }
    return 'X';
};

const getWaitTime = (startTime, arrvieInputTime, arriveButtonTime) => {
    if(startTime) {
        if(arrvieInputTime) {
            return ValueMisc.parseAndMinusToHhmm(arrvieInputTime, startTime, true);
        }
        else if(arriveButtonTime) {
            return ValueMisc.parseAndMinusToHhmm(arriveButtonTime, startTime, true);
        }
    }
    return 'X';
};

// 상차시작시간과 도착요청시간의 날짜를 비교하여 배차구분(당일/익일)을 반환하는 함수
// 상온센터인 경우만 적용하고 신선센터는 기존값을 유지
const getTransType = (rec) => {
    if (!rec) return '';

    // dcTypeCd가 'A'가 아니면 기존 값(기본값)을 그대로 반환
    if (rec.dcTypeCd !== 'A') {
        return rec.transType || ''; // 기존 transType 필드값 또는 기본값
    }

    // dcTypeCd가 'A'인 경우에만 당일/익일 계산 실행
    const loadDate = ValueMisc.parseToDate(rec.loadStTime);
    const arrDate = ValueMisc.parseToDate(rec.arrReqTime);

    if (!loadDate || !arrDate) {
        return '';
    }

    // parseToDate가 Date.UTC 기반이므로 getUTC* 메서드로 날짜를 비교해야 합니다.
    const isSameDay = 
        loadDate.getUTCFullYear() === arrDate.getUTCFullYear() &&
        loadDate.getUTCMonth() === arrDate.getUTCMonth() &&
        loadDate.getUTCDate() === arrDate.getUTCDate();

    return isSameDay ? '당일' : '익일';
};

const ArrivalOnTimeReportMetaForCenter = {
    instructions: {
        // title: '정시도착 Report',
        headerRowSpan: 3,
        headerRows: [],
        headerBackgroundColor: 'FFFFFF88', // light yellow
    },
    // getExtraHeaders: (records) => ValueMisc.makeDurationHeader(records),
};

const ArrivalOnTimeReportMetaForTranscom = {
    instructions: {
        // title: '정시도착 Report',
        headerRowSpan: 3,
        headerRows: [],
        headerBackgroundColor: 'FFFFFF88', // light yellow
    },
    // getExtraHeaders: (records) => ValueMisc.makeDurationHeader(records),
};

export const ArrivalOnTimeReportMeta = {
    transporter: ArrivalOnTimeReportMetaForTranscom,
    center: ArrivalOnTimeReportMetaForCenter,
};

// width는 8의 배수가 좋아. 40, 48, 56, 64, 72, 80, 88, 96, 104, 112, 120, 128, 136, 144, 152, 160, 168..

// 운송사용 정시도착 레포트 칼럼 정의:
const aotColumnsForTransporter = [
    { id: 'planDate', width: 96, label: '상차일자', option:{type:TableColumnType.DATE} },
    { id: 'storeId', width: 56, label: '점포ID', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'storeName', width: 96, label: '점포명', option:{type:TableColumnType.TEXT} },
    {
        id: 'hocha', width: 40, label: '호차', noTotal: true,
        option:{align: AppWord.CENTER, type:TableColumnType.INTEGER}
    },
    {
        id: 'transType', width: 88, label: '배차구분',
        excel: (rec) => getTransType(rec),
        option:{
            align: AppWord.CENTER,
            type:TableColumnType.TEXT
        }
    },
    { id: 'comName', width: 120, label: '운송사', option:{type:TableColumnType.TEXT} },
    { id: 'vehTypeName', width: 104, label: '차종', option:{type:TableColumnType.TEXT} },
    { id: 'vehPlates', width: 136, label: '차량번호', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'driverName', width: 96, label: '기사명', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    {
        id: 'dptrReqTime', width: 152, label: '출발요청시간',
        option:{type:TableColumnType.DATETIME},
        superHeaders: [{label:'물류센터', colSpan:7},{label:'운송파트', colSpan:2},]
    },
    {
        id: 'arrReqTime', width: 152, label: '도착요청시간',
        option:{type:TableColumnType.DATETIME},
        superHeaders: [null, null]
    },
    {
        id: 'loadStTime', width: 152, label: '상차시작시간',
        option:{type:TableColumnType.DATETIME},
        superHeaders: [null, {label:'출고파트', colSpan:5}]
    },
    {
        id: 'loadEnTime', width: 152, label: '상차종료시간',
        option:{type:TableColumnType.DATETIME},
        superHeaders: [null, null]
    },
    {
        id: 'prosDptrTime', width: 152, label: '출발예상시간',
        option:{type:TableColumnType.DATETIME},
        superHeaders: [null, null]
    },
    {
        id: 'prosArrTime', width: 152, label: '도착예상시간',
        option:{type:TableColumnType.DATETIME},
        superHeaders: [null, null]
    },
    {
        id: 'dcKeyDptrTime', width: 152, label: 'DSC출발',        
        option:{type:TableColumnType.DATETIME},
        superHeaders: [null, null]
    },
    {
        id: 'inputArrTime', width: 152, label: '도착(점포입력)',        
        option:{type:TableColumnType.DATETIME},
        superHeaders: [{label: '시간관리', colSpan: 6}, {label:'점포', colSpan:4}]
    },
    {
        id: 'storeKeyArrTime', width: 152, label: '점포도착(F2)',        
        option:{type:TableColumnType.DATETIME},
        superHeaders: [null, null]
    },
    {
        id: 'dischStartKeyTime', width: 152, label: '하차시작(F3)',        
        option:{type:TableColumnType.DATETIME},
        superHeaders: [null, null]
    },
    {
        id: 'storeKeyDptrTime', width: 152, label: '점포출발(F4)',        
        option:{type:TableColumnType.DATETIME},
        superHeaders: [null, null]
    },
    {
        id: 'storeBcdArrTime', width: 152, label: '도착감지시간',        
        option:{type:TableColumnType.DATETIME},
        superHeaders: [null, {label: '이벤트감지', colSpan:2}]
    },
    {
        id: 'storeKeyArrDist', width: 120, label: '도착감지거리', noTotal: true,
        option: {type: TableColumnType.INTEGER},
        superHeaders: [null, null]
    },
    // DotStoreTime = getDotStoreTimeHit(voo.getArr_req_date(), voo.getArr_req_time(),voo.getInput_arr_date(),voo.getInput_arr_time());
    {
        id: 'dotStoreTime', width: 120, label: 'DOT(점포)',
        excel: (row, value) => {
            return ValueMisc.getDotStoreTimeHit(row.arrReqTime, row.inputArrTime, 30);
        },
        option:{type:TableColumnType.TEXT}
    },
    // DotTerminalTime = getDotStoreTimeHit(voo.getArr_req_date(), voo.getArr_req_time(),voo.getStore_key_arr_time());
    {
        id: 'dotTerminalTime', width: 120, label: 'DOT(단말기)',
        excel: (row, value) => {
            return ValueMisc.getDotStoreTimeHit(row.arrReqTime, row.storeKeyArrTime, 30);
        },
        option:{align: AppWord.CENTER, type:TableColumnType.TEXT}
    },
    // LoadDelayTime = getDotStoreTime(voo.getLoad_en_date(),voo.getLoad_en_time(), voo.getLoad_st_date(),voo.getLoad_st_time() );
    {
        id: 'loadDelayTime', width: 120, label: '상차시간',
        excel: (row, value) => {
            return ValueMisc.parseAndMinusToHhmm(row.loadEnTime, row.loadStTime, true);
        },
        option:{align: AppWord.CENTER, type:TableColumnType.TEXT}
    },
    // TransRunTime = getTransRunTime( voo.getStore_key_arr_time(), voo.getDc_key_dptr_time() );
    {
        id: 'transRunTime', width: 120, label: '운행시간',
        excel: (row, value) => {
            return ValueMisc.parseAndMinusToHhmm(row.storeKeyArrTime, row.dcKeyDptrTime, false);
        },
        option:{align: AppWord.CENTER, type:TableColumnType.TEXT}
    },
    // WaitTime = getWaitTime( voo.getDisch_start_key_time(),voo.getInput_arr_date(),voo.getInput_arr_time(), voo.getStore_key_arr_time() );
    {
        id: 'waitTime', width: 120, label: '하차대기시간',
        excel: (row, value) => {
            return getWaitTime(row.dischStartKeyTime, row.inputArrTime, row.storeKeyArrTime);
        },
        option:{align: AppWord.CENTER, type:TableColumnType.TEXT}
    },
    // StayTime = getStayTime( voo.getStore_key_dptr_time(),voo.getInput_arr_date(),voo.getInput_arr_time(), voo.getStore_key_arr_time() );
    {
        id: 'stayTime', width: 120, label: '점포체류시간',
        excel: (row, value) => {
            return getStayTime(row.storeKeyDptrTime, row.inputArrTime, row.storeKeyArrTime);
        },
        option:{align: AppWord.CENTER, type:TableColumnType.TEXT}
    },
    { id: 'dcReturnNote', width: 120, label: '비고', option:{type:TableColumnType.TEXT} },
    {
        id: 'dcReturnKpp', width: 96, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label: '팔렛트반납', colSpan:2}]
    },
    {
        id: 'dcReturnAju', width: 96, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null]
    },
    {
        id: 'dcReturnSpt', width: 96, label: '녹색(532)', 
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label: 'Single Pick Tray반납', colSpan:2}]
    },
    {
        id: 'dcReturnSpt533', width: 96, label: '보라색(533)', 
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null]
    },
    {
        id: 'dcReturnFull', width: 96, label: 'Full', 
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label: '보냉커버반납', colSpan:2}]
    },
    {
        id: 'dcReturnHalf', width: 96, label: 'Half', 
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null]
    },
    { id: 'dcReturnNjc800', width: 120, label: 'NJC800반납', option:{type:TableColumnType.INTEGER} },
    { id: 'dcReturnRollcage', width: 120, label: 'RollCage반납', option:{type:TableColumnType.INTEGER} },
    { id: 'dcReturnDanpra', width: 120, label: 'Danpra반납', option:{type:TableColumnType.INTEGER} },
    { id: 'dcReturnEtc', width: 120, label: '기타반납', option:{type:TableColumnType.INTEGER} },
];


// 센터용 정시도착 이벤트 레포트 컬럼 정의
const aotEventColumnsForCenter = [
    { id: 'planDate', width: 96, label: '상차일자', option:{type:TableColumnType.DATE} },
    { id: 'storeId', width: 56, label: '점포ID', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'storeName', width: 96, label: '점포명', option:{type:TableColumnType.TEXT} },
    {
        id: 'hocha', width: 40, label: '호차', noTotal: true,
        option:{align: AppWord.CENTER, type:TableColumnType.INTEGER}
    },
    {
        id: 'transType', width: 88, label: '배차구분',
        excel: (rec) => getTransType(rec),
        option:{
            align: AppWord.CENTER,
            type:TableColumnType.TEXT
        }
    },
    { id: 'comName', width: 120, label: '운송사', option:{type:TableColumnType.TEXT} },
    { id: 'vehTypeName', width: 104, label: '차종', option:{type:TableColumnType.TEXT} },
    { id: 'vehPlates', width: 136, label: '차량번호', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'driverName', width: 96, label: '기사명', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    {
        id: 'dptrReqTime', width: 152, label: '출발요청시간',        
        option:{type:TableColumnType.DATETIME},
        superHeaders: [{label:'물류센터', colSpan:7},{label:'운송파트', colSpan:2},]
    },
    {
        id: 'arrReqTime', width: 152, label: '도착요청시간',        
        option:{type:TableColumnType.DATETIME},
        superHeaders: [null, null]
    },
    {
        id: 'loadStTime', width: 152, label: '상차시작시간',        
        option:{type:TableColumnType.DATETIME},
        superHeaders: [null, {label:'출고파트', colSpan:5}]
    },
    {
        id: 'regDate', width: 152, label: '상차종료시간', // 2022-03-14 상차종료시간-> TSR발행시간으로 수정        
        option:{type:TableColumnType.DATETIME},
        superHeaders: [null, null]
    },
    {
        id: 'prosDptrTime', width: 152, label: '출발예상시간',        
        option:{type:TableColumnType.DATETIME},
        superHeaders: [null, null]
    },
    {
        id: 'prosArrTime', width: 152, label: '도착예상시간',        
        option:{type:TableColumnType.DATETIME},
        superHeaders: [null, null]
    },
    {
        id: 'dcBcdDptrTime', width: 152, label: 'DSC출발',        
        option:{type:TableColumnType.DATETIME},
        superHeaders: [null, null]
    },
    {
        id: 'inputArrTime', width: 152, label: '도착(점포입력)',        
        option:{type:TableColumnType.DATETIME},
        superHeaders: [{label: '시간관리', colSpan: 4}, {label:'점포', colSpan:4}]
    },
    {
        id: 'storeBcdArrTime', width: 152, label: '점포도착',        
        option:{type:TableColumnType.DATETIME},
        superHeaders: [null, null]
    },
    {
        id: 'dischStartKeyTime', width: 152, label: '하차시작(A,B버튼)',        
        option:{type:TableColumnType.DATETIME},
        superHeaders: [null, null]
    },
    {
        id: 'storeBcdDptrTime', width: 152, label: '점포출발',        
        option:{type:TableColumnType.DATETIME},
        superHeaders: [null, null]
    },
    {
        id: 'dotStoreTime', width: 120, label: 'DOT(점포)',
        excel: (row, value) => {
            return ValueMisc.getDotStoreTimeHit(row.arrReqTime, row.inputArrTime, 30);
        },
        option:{align: AppWord.CENTER, type:TableColumnType.TEXT}
    },
    {
        id: 'dotTerminalTime', width: 120, label: 'DOT(단말기)',
        excel: (row, value) => {
            return ValueMisc.getDotStoreTimeHit(row.arrReqTime, row.storeBcdArrTime, 30);
        },
        option:{align: AppWord.CENTER, type:TableColumnType.TEXT}
    },
    {
        id: 'loadDelayTime', width: 120, label: '상차시간',
        excel: (row, value) => {
            return ValueMisc.parseAndMinusToHhmm(row.loadEnTime, row.loadStTime, true);
            // return ValueMisc.getLoadDelayTime(row.loadEnTime, row.loadStTime);
        },
        option:{align: AppWord.CENTER, type:TableColumnType.TEXT}
    },
    {
        id: 'transRunTime', width: 120, label: '운행시간',
        excel: (row, value) => {
            return ValueMisc.parseAndMinusToHhmm(row.storeKeyArrTime, row.dcKeyDptrTime, false);
        },
        option:{align: AppWord.CENTER, type:TableColumnType.TEXT}
    },
    {
        id: 'waitTime', width: 120, label: '하차대기시간',
        excel: (row, value) => {
            return getWaitTime(row.dischStartKeyTime, row.inputArrTime, row.storeBcdArrTime);
        },
        option:{align: AppWord.CENTER, type:TableColumnType.TEXT}
    },
    {
        id: 'stayTime', width: 120, label: '점포체류시간',
        excel: (row, value) => {
            return getStayTime(row.storeBcdDptrTime, null, row.storeBcdArrTime)
        },
        option:{align: AppWord.CENTER, type:TableColumnType.TEXT}
    },
    { id: 'dcReturnNote', width: 120, label: '비고', option:{type:TableColumnType.TEXT} },
    {
        id: 'dcReturnKpp', width: 96, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label: '팔렛트반납', colSpan:2}]
    },
    {
        id: 'dcReturnAju', width: 96, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null]
    },
    {
        id: 'dcReturnSpt', width: 96, label: '녹색(532)', 
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label: 'Single Pick Tray반납', colSpan:2}]
    },
    {
        id: 'dcReturnSpt533', width: 96, label: '보라색(533)', 
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null]
    },
    {
        id: 'dcReturnFull', width: 96, label: 'Full', 
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label: '보냉커버반납', colSpan:2}]
    },
    {
        id: 'dcReturnHalf', width: 96, label: 'Half', 
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null]
    },
    { id: 'dcReturnNjc800', width: 120, label: 'NJC800반납', option:{type:TableColumnType.INTEGER} },
    { id: 'dcReturnRollcage', width: 120, label: 'RollCage반납', option:{type:TableColumnType.INTEGER} },
    { id: 'dcReturnDanpra', width: 120, label: 'Danpra반납', option:{type:TableColumnType.INTEGER} },
    { id: 'dcReturnEtc', width: 120, label: '기타반납', option:{type:TableColumnType.INTEGER} },
    {
        id: 'tempr1', width: 96, label: '전면', noTotal: true,
        option:{type:TableColumnType.FLOAT},
        superHeaders: [{label:'도착보고시온도', colSpan:3}]
    },
    {
        id: 'tempr2', width: 96, label: '중면', noTotal: true,
        option:{type:TableColumnType.FLOAT},
        superHeaders: [null]
    },
    {
        id: 'tempr3', width: 96, label: '후면', noTotal: true,
        option:{type:TableColumnType.FLOAT},
        superHeaders: [null]
    },
    { id: 'dcReturnNote', width: 144, label: '비고', option:{type:TableColumnType.TEXT} },
    {
        id: 'dcReturnKpp', width: 96, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label: '팔렛트반납', colSpan:2}]
    },
    {
        id: 'dcReturnAju', width: 96, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null]
    },
    {
        id: 'dcReturnSpt', width: 96, label: '녹색(532)', 
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label: 'Single Pick Tray반납', colSpan:2}]
    },
    {
        id: 'dcReturnSpt533', width: 96, label: '보라색(533)', 
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null]
    },
    {
        id: 'dcReturnFull', width: 96, label: 'Full', 
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label: '보냉커버반납', colSpan:2}]
    },
    {
        id: 'dcReturnHalf', width: 96, label: 'Half', 
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null]
    },
    { id: 'dcReturnNjc800', width: 120, label: 'NJC800반납', option:{type:TableColumnType.INTEGER} },
    { id: 'dcReturnRollcage', width: 120, label: 'RollCage반납', option:{type:TableColumnType.INTEGER} },
    { id: 'dcReturnDanpra', width: 120, label: 'Danpra반납', option:{type:TableColumnType.INTEGER} },
    { id: 'dcReturnEtc', width: 120, label: '기타반납', option:{type:TableColumnType.INTEGER} },
];

// 센터용 정시도착 컬럼 정의
const aotColumnsForCenter = [
    { id: 'planDate', width: 96, label: '상차일자', option:{type:TableColumnType.DATE} },
    { id: 'storeId', width: 56, label: '점포ID', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'storeName', width: 96, label: '점포명', option:{type:TableColumnType.TEXT} },
    {
        id: 'hocha', width: 40, label: '호차', noTotal: true,
        option:{align: AppWord.CENTER, type:TableColumnType.INTEGER}
    },
    {
        id: 'transType', width: 88, label: '배차구분',
        excel: (rec) => getTransType(rec),
        option:{
            align: AppWord.CENTER,
            type:TableColumnType.TEXT
        }
    },
    { id: 'comName', width: 120, label: '운송사', option:{type:TableColumnType.TEXT} },
    { id: 'vehTypeName', width: 104, label: '차종', option:{type:TableColumnType.TEXT} },
    { id: 'vehPlates', width: 136, label: '차량번호', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'driverName', width: 96, label: '기사명', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    {
        id: 'dptrReqTime', width: 152, label: '출발요청시간',        
        option:{type:TableColumnType.DATETIME},
        superHeaders: [{label:'물류센터', colSpan:7},{label:'운송파트', colSpan:2},]
    },
    {
        id: 'arrReqTime', width: 152, label: '도착요청시간',        
        option:{type:TableColumnType.DATETIME},
        superHeaders: [null, null]
    },
    {
        id: 'loadStTime', width: 152, label: '상차시작시간',        
        option:{type:TableColumnType.DATETIME},
        superHeaders: [null, {label:'출고파트', colSpan:5}]
    },
    {
        id: 'loadEnTime', width: 152, label: '상차종료시간',        
        option:{type:TableColumnType.DATETIME},
        superHeaders: [null, null]
    },
    {
        id: 'prosDptrTime', width: 152, label: '출발예상시간',        
        option:{type:TableColumnType.DATETIME},
        superHeaders: [null, null]
    },
    {
        id: 'prosArrTime', width: 152, label: '도착예상시간',        
        option:{type:TableColumnType.DATETIME},
        superHeaders: [null, null]
    },
    {
        id: 'dcKeyDptrTime', width: 152, label: 'DSC출발(F1)',        
        option:{type:TableColumnType.DATETIME},
        superHeaders: [null, null]
    },
    {
        id: 'inputArrTime', width: 152, label: '도착(점포입력)',        
        option:{type:TableColumnType.DATETIME},
        superHeaders: [{label: '시간관리', colSpan: 6}, {label:'점포', colSpan:4}]
    },
    {
        id: 'storeKeyArrTime', width: 152, label: '점포도착(F2)',        
        option:{type:TableColumnType.DATETIME},
        superHeaders: [null, null]
    },
    {
        id: 'dischStartKeyTime', width: 152, label: '하차시작(F3)',        
        option:{type:TableColumnType.DATETIME},
        superHeaders: [null, null]
    },
    {
        id: 'storeKeyDptrTime', width: 152, label: '점포출발(F4)',        
        option:{type:TableColumnType.DATETIME},
        superHeaders: [null, null]
    },
    {
        id: 'storeBcdArrTime', width: 152, label: '도착감지시간',        
        option:{type:TableColumnType.DATETIME},
        superHeaders: [null, {label:'이벤트감지', colSpan:2}]
    },
    {
        id: 'storeKeyArrDist', width: 96, label: '도착감지거리', noTotal: true,
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null]
    },
    {
        id: 'dotStoreTime', width: 120, label: 'DOT(점포)',
        excel: (row, value) => {
            return ValueMisc.getDotStoreTimeHit(row.arrReqTime, row.inputArrTime, 30);
        },
        option:{align: AppWord.CENTER, type:TableColumnType.TEXT}
    },
    {
        id: 'dotTerminalTime', width: 120, label: 'DOT(단말기)',
        excel: (row, value) => {
            return ValueMisc.getDotStoreTimeHit(row.arrReqTime, row.storeKeyArrTime, 30);
        },
        option:{align: AppWord.CENTER, type:TableColumnType.TEXT}
    },
    // LoadDelayTime = getDotStoreTime(voo.getLoad_en_date(),voo.getLoad_en_time(), voo.getLoad_st_date(),voo.getLoad_st_time() );
    {
        id: 'loadDelayTime', width: 120, label: '상차시간',
        excel: (row, value) => {
            return ValueMisc.parseAndMinusToHhmm(row.loadEnTime, row.loadStTime, true);
        },
        option:{align: AppWord.CENTER, type:TableColumnType.TEXT}
    },
    // TransRunTime = getTransRunTime( voo.getStore_key_arr_time(), voo.getDc_key_dptr_time() );
    {
        id: 'transRunTime', width: 120, label: '운행시간',
        excel: (row, value) => {
            return ValueMisc.parseAndMinusToHhmm(row.storeKeyArrTime, row.dcKeyDptrTime, false);
        },
        option:{align: AppWord.CENTER, type:TableColumnType.TEXT}
    },
    // WaitTime = getWaitTime( voo.getDisch_start_key_time(),voo.getInput_arr_date(),voo.getInput_arr_time(), voo.getStore_key_arr_time() );
    {
        id: 'waitTime', width: 120, label: '하차대기시간',
        excel: (row, value) => {
            return getWaitTime(row.dischStartKeyTime, row.inputArrTime, row.storeKeyArrTime);
        },
        option:{align: AppWord.CENTER, type:TableColumnType.TEXT}
    },
    // StayTime = getStayTime( voo.getStore_key_dptr_time(),voo.getInput_arr_date(),voo.getInput_arr_time(), voo.getStore_key_arr_time() );
    {
        id: 'stayTime', width: 120, label: '점포체류시간',
        excel: (row, value) => {
            return getStayTime(row.storeKeyDptrTime, row.inputArrTime, row.storeKeyArrTime);
        },
        option:{align: AppWord.CENTER, type:TableColumnType.TEXT}
    },
    { id: 'dcReturnNote', width: 144, label: '비고', option:{type:TableColumnType.TEXT} },
    {
        id: 'dcReturnKpp', width: 96, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'팔렛트반납', colSpan:2}]
    },
    {
        id: 'dcReturnAju', width: 96, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null]
    },
    {
        id: 'dcReturnSpt', width: 96, label: '녹색(532)',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'Single Pick Tray반납', colSpan:2}]
    },
    {
        id: 'dcReturnSpt533', width: 96, label: '보라색(533)',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null]
    },
    {
        id: 'dcReturnFull', width: 96, label: 'Full',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'보냉커버반납', colSpan:2}]
    },
    {
        id: 'dcReturnHalf', width: 96, label: 'Half',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null]
    },
    { id: 'dcReturnNjc800', width: 120, label: 'NJC800반납', option:{type:TableColumnType.INTEGER} },
    { id: 'dcReturnRollcage', width: 120, label: 'RollCage반납', option:{type:TableColumnType.INTEGER} },
    { id: 'dcReturnDanpra', width: 120, label: 'Danpra반납', option:{type:TableColumnType.INTEGER} },
    { id: 'dcReturnEtc', width: 120, label: '기타반납', option:{type:TableColumnType.INTEGER} },
    {
        id: 'tempr1', width: 96, label: '전면', noTotal: true,
        option:{type:TableColumnType.FLOAT},
        superHeaders: [{label:'도착보고시온도', colSpan:3}]
    },
    {
        id: 'tempr2', width: 96, label: '중면', noTotal: true,
        option:{type:TableColumnType.FLOAT},
        superHeaders: [null]
    },
    {
        id: 'tempr3', width: 96, label: '후면', noTotal: true,
        option:{type:TableColumnType.FLOAT},
        superHeaders: [null]
    },
];

export const ArrivalOnTimeReportExcelColumns = {
    center: {
        columns: aotColumnsForCenter,
        eventColumns: aotEventColumnsForCenter
    },
    transporter: {
        columns: aotColumnsForTransporter,
        eventColumns: aotColumnsForTransporter // 운송사용은 이벤트용과 동일
    }
}